export const SAVE_USER_DATA = 'SAVE_USER_DATA';
export const LOG_OUT = 'LOG_OUT';